import { useEffect, useRef } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '@lipaflow/shared'

/**
 * Forget every fetched screen when the signed-in person or organisation
 * changes, signing out included.
 *
 * Query keys name a screen ('analytics', 'overview'), not whose it is. Signing
 * out of one organisation and into another in the same tab showed the first
 * one's figures under the second one's name until a reload (seen 2026-10-11).
 * Signing out passes through the sign-in page, which shows no organisation
 * data, so the cache is empty before the next account's screens ask.
 */
export function useClearCacheOnAccountChange(): void {
  const queryClient = useQueryClient()
  const account = useAuthStore((s) => `${s.user?.id ?? ''}:${s.tenant?.id ?? ''}`)
  const previous = useRef(account)
  useEffect(() => {
    if (previous.current === account) return
    previous.current = account
    queryClient.clear()
  }, [account, queryClient])
}
